import { motion } from "framer-motion";
import { Check } from "lucide-react";
import LeadForm from "./LeadForm";
import { Eyebrow } from "./Reveal";
import { IMAGES } from "@/lib/api";

const fade = (d) => ({ initial: { opacity: 0, y: 20 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.9, delay: d, ease: [0.22, 1, 0.36, 1] } });

export default function Hero() {
  return (
    <section className="relative overflow-hidden" data-testid="hero-section">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 pt-28 pb-20 sm:pt-36 lg:pb-32 grid lg:grid-cols-12 gap-12 lg:gap-8 items-center">
        <div className="lg:col-span-6 relative z-10">
          <motion.div {...fade(0.05)}><Eyebrow>Guida gratuita · 7 giorni</Eyebrow></motion.div>
          <motion.h1 {...fade(0.15)} className="font-display text-[44px] leading-[0.98] sm:text-6xl lg:text-7xl tracking-tight font-medium mt-5">
            Raggiungi la tua versione migliore, <em className="text-[#C05746]">senza</em> estremismi.
          </motion.h1>
          <motion.p {...fade(0.3)} className="mt-6 text-lg leading-relaxed text-[#5A625C] max-w-lg">
            Perdi grasso, costruisci tono e torna a sentirti forte. Senza 1200 calorie al giorno, senza allenamenti punitivi.
            La guida che do alle mie clienti nella prima settimana, gratis.
          </motion.p>
          <motion.ul {...fade(0.4)} className="mt-6 space-y-2 text-[15px]">
            {["7 azioni semplici, da inserire nella tua routine una al giorno", "Allenamento base da fare anche a casa", "Come mangiare abbastanza (e meglio)"].map((t) => (
              <li key={t} className="flex items-center gap-3">
                <span className="w-5 h-5 rounded-full bg-[#748E63]/15 flex items-center justify-center"><Check className="w-3 h-3 text-[#748E63]" /></span>
                {t}
              </li>
            ))}
          </motion.ul>
          <motion.div {...fade(0.5)} className="mt-8"><LeadForm id="hero-lead" source="hero" /></motion.div>
        </div>
        <motion.div {...fade(0.25)} className="lg:col-span-6 relative">
          <div className="relative ml-auto w-[88%] lg:w-full max-h-[70vh] aspect-[4/5] rounded-[2rem] overflow-hidden grain">
            <img src={IMAGES.hero} alt="Chiara Piccioni, fitness coach per donne" className="w-full h-full object-cover object-[50%_20%]" />
          </div>
          <div className="absolute -bottom-6 left-0 sm:left-4 bg-white/80 backdrop-blur-xl border border-[#E5E1D8] rounded-2xl px-5 py-4 max-w-[230px]" data-testid="hero-badge">
            <p className="font-display text-3xl leading-none">12 settimane</p>
            <p className="text-xs text-[#5A625C] mt-1">il tempo medio per vedere la ricomposizione allo specchio</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
